const experience = [
  {
    company: 'Intel Corporation',
    position: 'Big Data Software Engineer Intern',
    link: 'https://intel.com',
    daterange: 'June 2021 - August 2021',
    points: [
      'Worked in Analytics Zoo team aiming to scale TensorFlow/PyTorch applications to distributed big data frameworks.',
      'Encapsulated commonly used big data pre-processing logic into 10+ PySpark DataFrame functions, e.g., transform continuous columns to categorical columns, which have been merged into the Analytics Zoo GitHub repository.',
      'Built a recommender system using the DeepFm model on WeChat dataset of more than 10 millions video feeds, to predict the probability of users’ interactive actions (likes, clicks on avatars, favorites) according to historical n-day behavior data and video information.',
      'Scaled out PySpark data pre-processing and PyTorch prediction model from single node to YARN clusters utilizing the Orca framework, which reduced the model processing time by 20%.',
    ],
  },
  {
    company: 'UMich Foreseer Group',
    position: 'Research Assistant Instructed by Prof. Qiaozhu Mei',
    link: 'http://foreseer.si.umich.edu/',
    daterange: 'October 2019 - December 2020',
    points: [
      'Proposed a novel method to improve many existing graph fingerprinting methods by parameterizing with a multi-channel fuzzy histogram and CNN, which increases their graph-level prediction accuracies by 4% to 7% on average, and consistently outperforms or matches the performance of advanced higher-order GNN methods.',
      'Developed smooth fuzzy histograms with PyTorch to convert node-level fingerprints to universal graph representations, and visualized hidden layers and graph structures with TensorBoard and NetworkX to find performance bottlenecks.',
      'Designed and ran the experiments on synthetic and real-world datasets using the lab\'s CUDA machines and AWS EC2.',
      'Publication: A Simple Yet Effective Method Improving Graph Fingerprints for Graph-Level Prediction. Jiaxin Ying*, Jiaqi Ma*, Qiaozhu Mei. The WebConf (WWW) 2021 Workshop on Graph Learning Benchmarks.',
    ],
  },
  {
    company: 'UMich Situated Language & Embodied Dialogue Group',
    position: 'Research Assitant Instructed by Prof. Joyce Y. Chai',
    link: 'https://web.eecs.umich.edu/~chaijy/',
    daterange: 'May 2020 - January 2021',
    points: [
      'Augmented the ACT dataset by adding human-labeled bounding boxes with annotations and cleansed the data.',
      'Designed and implemented two noun grounding modules by adapting Faster RCNN networks and attention networks, to determine bounding boxes with inputs of images, captions and noun embeddings from ResNet, BERT and word2vec.',
      'Participated in running experiments to compare our verb acquisition model with a mental attention layer pre-trained from noun grounding task with baseline models.',
      'Wrote the first draft of Related Work section of the paper and came up with multiple suggestions to other parts.',
    ],
  },
];

export default experience;
